import React from 'react';
// template components
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
// native components
import ProductCoChart from '../../../../components/productCoChart';

const config = {
  productComparisonChart: {
    columns: [
      {
        Header: 'Reasons we can share your personal information',
        headerCellClassName: 'criteria-health-institute',
        accessor: 'reason',
      },
      {
        Header: (<>Does NLTC share&#63;</>),
        accessor: 'share',
      },
      {
        Header: (<>Can you limit this sharing&#63;</>),
        accessor: 'limit',
      },
    ],
    data: [
      {
        reason: (<><strong>For our everyday business purposes&#8212;</strong>such as
          to process your transactions, maintain your account(s), respond to court orders
          and legal investigations, or report to credit bureaus, cybersecurity and fraud prevention, and as otherwise authorized or required by law</>),
        share: (<>Yes</>),
        limit: (<>No</>),
      },
      {
        reason: (<><strong>For our marketing purposes&#8212;</strong>to offer our products and services to you</>),
        share: (<>Yes</>),
        limit: (<>No</>),
      },
      {
        reason: (<><strong>For joint marketing with other financial companies</strong></>),
        share: (<>No</>),
        limit: (<>No</>),
      },
      {
        reason: (<><strong>For our affiliates&#39; everyday business purposes&#8212;</strong>information about your transactions and experiences</>),
        share: (<>No</>),
        limit: (<>No</>),
      },
      {
        reason: (<><strong>For our affiliates&#39; everyday business purposes&#8212;</strong>information about your creditworthiness</>),
        share: (<>No</>),
        limit: (<>No</>),
      },
      {
        reason: (<><strong>For our affiliates to market to you</strong></>),
        share: (<>No</>),
        limit: (<>No</>),
      },
      {
        reason: (<><strong>For nonaffiliates to market to you</strong></>),
        share: (<>No</>),
        limit: (<>No</>),
      },
      {
        reason: (<><strong>As authorized by you </strong></>),
        share: (<>Yes</>),
        limit: (<>Yes&#42;</>),
      },
    ],
    hideSectionHeading: true,
    sectionHeading: <>Which type of annuity will help you meet your goals best&#63;</>,
  },
};

export default () => (
  <>
    <SectionContainer
      id='nltc-information-sharing-product-comparison-chart'
      backgroundVariant='lightC'
      themeType='lightTheme'
      className='nmx-nested nmx-product-comparison-table'
      moduleName='product-comparison-chart-module'
      moduleVariation='A'
    >
      <Row align='center'>
        <Col align='center'>
          <ProductCoChart
            id='nltc-information-sharing-product-comparison-chart'
            data-app-name='nltc-information-sharing-product-comparison-chart'
            data-static-config={config} />
        </Col>
      </Row>
    </SectionContainer>
  </>
);
